import { defineStore } from "pinia";

const API_NAME = "rota";
const API_VERSION = "/v1";

const CACHE_TIME_MINUTES = 60 * 24;
const MAX_PAGE_SIZE = 50;

export const useRotaAgenciesStore = defineStore(
  "rotaagencies",
  () => {
    const getRotaAgenciesForAgencySelection = async function () {
      const myInit = {
        queryStringParameters: {
          pageSize: MAX_PAGE_SIZE,
          sort: JSON.stringify({ initials: 1 }),
        },
      };

      return this.$api
        .getAllPages(API_NAME, `${API_VERSION}/rota-agencies`, myInit)
        .then((response) => {
          if (response === false) {
            return [];
          }
          if (response?._embedded["rota-agencies"] === undefined) {
            throw new Error(
              "pinia client: error fetching rota agencies (no embedded rota-agencies found)",
            );
          }
          return response._embedded["rota-agencies"];
        });
    };

    return {
      getRotaAgenciesForAgencySelection,
    };
  },
  {
    localStorageCache: [
      {
        function: "getRotaAgenciesForAgencySelection",
        options: {
          cacheTimeMinutes: CACHE_TIME_MINUTES,
        },
      },
    ],
  },
);
